<template>
    <div>
        <div class="row">
			<div class="col-lg-12 mb-3">
				<b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
				<b-card :header="$t('general.tie_in_management.revision.title')" header-tag="h3" class="bg-default-card">
					<revision-control-table ref="rt" actionWidth='90px' @pressEdit="onEditRow" @pressDelete="onDeleteRow" @pressAdd="onAddRow" @pressReturn="onReturn">
						<span slot="return">
							{{$t('general.buttons.return_to.return_to_tie_in')}}
						</span>
						<span slot="add">
							{{ $t('general.tie_in_management.revision.create_button') }}
						</span>
					</revision-control-table>
				</b-card>
			</div>
		</div>

        <b-modal :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" ref="editModal" id="editModal" :title="actionTitle" size="lg" @ok="saveAction" :ok-disabled="$store.state.ajax_in_progress || (row && !$store.getters.hasPermission(['project_revisions'], ['update']))">
            <div class="row">
				<div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.tie_in_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.tie_in_nr" @input="tieInBlur">
                        </div>
                    </div>

					<div class="row mb-3" v-if="model.tie_in_nr != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.line') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedLine"
                                :options="currentLine"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isLineLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="line_number" track-by="id"
                                :selectLabel="''"
                                @search-change="onLineSearch"
                                @input="updateLine"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedLine != null"
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedLine"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.progress_status') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedProgressStatus"
                                :options="currentProgressStatus"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isProgressStatusLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="info" track-by="id"
                                :selectLabel="''"
                                @search-change="onProgressStatusSearch"
                                @input="updateProgressStatus"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedProgressStatus != null"
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedProgressStatus"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

					<div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.tie_in_type') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select class="form-control" v-model="model.tie_in_type">
                                <option v-for="tie_in_type in tie_in_types" :value="tie_in_type.name" :key="tie_in_type.name">{{tie_in_type.name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.field_area') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.field_area"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.old_line_number') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.old_line_number">
                        </div>
                    </div>

					<div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.p_and_id') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.p_and_id">
                        </div>
                    </div>

					<div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.size') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.size">
                        </div>
                    </div>

					<div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.rating') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.rating">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.insulation_to_remove') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.insulation_to_remove" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.insulation_to_remove == 1">
                        <div class="col-lg-4">
                            <label>{{ $t('table.insulation_to_remove_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.insulation_to_remove_date"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.wall_thickness_measure') }}</label>
                        </div>
                        <div class="col-lg-8 mt-3" style="z-index: 0">
                            <toggle-button v-model="model.wall_thickness_measure" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.wall_thickness_measure == 1">
                        <div class="col-lg-4">
                            <label>{{ $t('table.wall_thickness_measure_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.wall_thickness_measure_date"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.ndt') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.ndt">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.testing_pressure') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.testing_pressure">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.testing_medium') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.testing_medium">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.priority') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select class="form-control" v-model="model.priority">
                                <option v-for="priority in priorities" :value="priority.name" :key="priority.name">{{priority.name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.pressure_test') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0">
                            <toggle-button v-model="model.pressure_test" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                     <div class="row mb-3" v-if="model.pressure_test == 1">
                        <div class="col-lg-4">
                            <label>{{ $t('table.pressure_test_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.pressure_test_date"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.ped_category') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.ped_category">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.item_number') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <autocomplete @search="onItemNoSearch" :options="currentItemNo" v-model="model.item_number"></autocomplete>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.drawing_number') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <autocomplete @search="onDrawingNoSearch" :options="currentDrawingNo" v-model="model.drawing_number"></autocomplete>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.authorization_authority') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.authorization_authority" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.authorization_authority == 1">
                        <div class="col-lg-4">
                            <label>{{ $t('table.authorization_authority_date') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.authorization_authority_date"></flat-pickr>
                        </div>
                    </div>
				</div>

				<div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.pwht') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0">
                            <toggle-button :disabled="true" v-model="model.line.pwht" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.special_coating') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.special_coating" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.special_coating == 1">
                        <div class="col-lg-4">
                            <label>{{ $t('table.special_works_date') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.special_works_date"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.insulation_or_tracing_type') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.insulation_or_tracing_type">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.insulation_or_tracing_thickness') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.insulation_or_tracing_thickness">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.painting') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0">
                            <toggle-button v-model="model.painting" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.painting == 1">
                        <div class="col-lg-4">
                            <label>{{ $t('table.painting_date') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.painting_date"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.painting == 1">
                        <div class="col-lg-4">
                            <label>{{ $t('table.painting_code') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0">
                            <input type="text" class="form-control" v-model="model.painting_code">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.execution_working_group') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedTeam"
                                :options="currentTeam"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isTeamLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="name" track-by="id"
                                :selectLabel="''"
                                @search-change="onTeamSearch"
                                @input="updateTeam"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedTeam != null"
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedTeam"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="this.model.team_id != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.team_member') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedUser"
                                :options="currentUser"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isUserLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="fullname" track-by="id"
                                :selectLabel="''"
                                @search-change="onUserSearch"
                                @input="updateUser"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedUser != null"
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedUser"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

					<div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.heat_tracing') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0">
                            <toggle-button v-model="model.heat_tracing" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

					<div class="row mb-3" v-if="model.heat_tracing == 1">
                        <div class="col-lg-4">
                            <label>{{ $t('table.heat_tracing_date') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.heat_tracing_date"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.scaffolding') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0">
                            <toggle-button v-model="model.scaffolding" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.scaffolding == 1">
                        <div class="col-lg-4">
                            <label>{{ $t('table.scaffolding_date') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.scaffolding_date"></flat-pickr>
                        </div>
                    </div>

					<div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.supports') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0">
                            <toggle-button v-model="model.supports" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.supports == 1">
                        <div class="col-lg-4">
                            <label>{{ $t('table.supports_date') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.supports_date"></flat-pickr>
                        </div>
                    </div>

					<div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.golden_welds') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <toggle-button v-model="model.golden_welds" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.golden_welds == 1">
                        <div class="col-lg-4">
                            <label>{{ $t('table.golden_welds_date') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.golden_welds_date"></flat-pickr>
                        </div>
                    </div>

					<div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.work_finished') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2">
                            <toggle-button v-model="model.work_finished" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.work_finished == 1">
                        <div class="col-lg-4">
                            <label>{{ $t('table.work_finished_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.date"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.remark') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.remark"></textarea>
                        </div>
                    </div>

                   <div class="row mb-3" v-if="row">
                        <div class="col-lg-4">
                            <label>{{ $t('table.revision_number') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.revision_number">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.revision_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.revision_date"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.revision_number') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.revision_number">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.revision_description') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.revision_description"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.revision_reason') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="model.revision_reason_setting"
                                :options="currentReason"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isReasonLoading"
                                :preserve-search="true" 
                                placeholder=""
                                label="value" track-by="id" 
                                :selectLabel="''" 
                                @search-change="onReasonSearch"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.revision_reason_setting != null && typeof model.revision_reason_setting.id != 'undefined' && model.revision_reason_setting.id != null"  
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedProjectSetting"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.revision_remarks') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.revision_remarks"></textarea>
                        </div>
                    </div>
				</div>
			</div>

            <hr v-if="getData.getFiles.length > 0 && hasFilesReadPermission">
            <div class="row mt-2" v-if="getData.getFiles.length > 0 && hasFilesReadPermission">
                <div class="col-lg-12">
                    <label>{{ $t('table.uploaded_files') }}</label>
                </div>
                <div class="col-lg-6" v-for="file in getData.getFiles" :key="file.id">
                    <div class="card p-2">
                        <div style="width: 100%; display: block">
                            <p 
                                class="float-left customLink" 
                                @click="onDownloadFile(file.id)" 
                                :title="file.file_name"
                            >
                                {{file.file_name}}
                            </p>
                            <p 
                                v-if="hasFilesDeletePermission"
                                class="float-right p-0 m-0"
                            >
                                <i class='fa fa-2x fa-trash mt-2 text-danger sortable cursor-pointer' @click="onDeleteFile(file.id)"></i>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="row != null">
                <hr>
                <h3>{{ $t('table.related_isometrics') }}</h3>
                <data-table
                    :exportable="false" 
                    :search="false"
                    title=""
                    :rows="getData.isometricsData"
                    :rowsColor="getData.rowColors"
                    :columns="isometricsColumnData"
                    @rowClickDelete="onDeleteIsometricRow"
                    :paginate="false" 
                >
                </data-table>
                <i class="btn pull-right mt-2 fa fa-plus-square fa-2x" style="padding: 0 0 5px 0;" @click="onAddIsometric"></i>
                <div class="clearfix"></div>

                <hr>
                <h3>{{ $t('table.drawings') }}</h3>
                <data-table
                    :exportable="false" 
                    :search="false" 
                    title=""
                    :rows="getData.drawingsData"
                    :columns="drawingsColumnData"
                    @rowClickDelete="onDeleteIsometricRow"
                    :paginate="false" 
                >
                </data-table>
                <i class="btn pull-right mt-2 fa fa-plus-square fa-2x" style="padding: 0 0 5px 0;" @click="onAddDrawing"></i>
            </div>
        </b-modal>

        <b-modal :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" ref="addIsometricModal" :title="actionTitle" size="md" @ok="saveIsometricAction(...arguments, 'isometric')" :ok-disabled="this.$store.state.ajax_in_progress" @hidden="onEditRow(row)">
            <div class="row">
                <div class="col-lg-3">
                    <label>{{ $t('table.isometric') }}</label>
                </div>
                <div class="col-lg-9">
                    <multiselect v-model="selectedIsometrics"
                        :options="currentIsometrics"
                        :multiple="false"
                        :clear-on-select="true"
                        :hide-selected="false"
                        :loading="isIsometricLoading"
                        :preserve-search="true"
                        placeholder=""
                        label="info" track-by="id"
                        :selectLabel="''"
                        @search-change="onIsometricSearch"
                    >
                        <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                        <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                    </multiselect>
                </div>
            </div>
        </b-modal>

        <b-modal :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" ref="addDrawingModal" :title="actionTitle" size="md" @ok="saveIsometricAction(...arguments, 'drawing')" :ok-disabled="this.$store.state.ajax_in_progress" @hidden="onEditRow(row)">
            <div class="row">
                <div class="col-lg-3">
                    <label>{{ $t('table.drawing') }}</label>
                </div>
                <div class="col-lg-9">
                    <multiselect v-model="selectedIsometrics"
                        :options="currentIsometrics"
                        :multiple="false"
                        :clear-on-select="true"
                        :hide-selected="false"
                        :loading="isDrawingLoading"
                        :preserve-search="true"
                        placeholder=""
                        label="info" track-by="id"
                        :selectLabel="''"
                        @search-change="onDrawingSearch"
                    >
                        <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                        <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                    </multiselect>
                </div>
            </div>
        </b-modal>

        <revision-control-modal :model.sync="this.model" ref="addModal" :title="actionTitle" settingType="reason_for_revision" @ok="saveAction"/>

        <confirm-dialog ref="deleteModal" :title="actionTitleDelete" @buttonClick="deleteAction">
           {{ deleteMessage }}
        </confirm-dialog>

        <confirm-dialog ref="deleteIsometricModal" :title="actionTitle" @buttonClick="deleteIsometricAction">
            {{ $t('messages.delete') }}
        </confirm-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import miniToastr from 'mini-toastr';
import Autocomplete from '@/components/global/miscellaneous/Autocomplete.vue';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Multiselect from 'vue-multiselect';
import vue2Dropzone from 'vue2-dropzone';
import '@/assets/css/vue2Dropzone.css';
import RevisionControlModal from '@/components/global/modals/RevisionControlModal.vue';
import RevisionControlTable from '@/components/global/tables/RevisionControlTable.vue';

export default {
    name: 'tie_in_management_revisioncontrol',
    components: {
        DataTable,
        ConfirmDialog,
        Multiselect,
        flatPickr,
        vueDropzone: vue2Dropzone,
        Autocomplete,
        RevisionControlModal,
        RevisionControlTable,
    },
    data() {
        return {
            breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/'
                },
                {
                    text: Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name,
                    to: '/project/'+this.$route.params.id,
                },
                {
                    text: Vue.i18n.translate('general.tie_in_management.title'),
                    active: true
                }
            ],
            tableName: 'tie_in',
            tableNameTranslated: Vue.i18n.translate('general.revision.main_title'),

            row: null,
            rowIsometric: null,

            actionTitle: '',
            actionTitleDelete: '',
            deleteMessage: '',

            //check if already opened
            already_opened_warning: false,
            //end check if already opened

            currentDrawingNo: [],
            currentItemNo: [],

            selectedLine: null,
            currentLine: [],
            isLineLoading: false,

            selectedProgressStatus: null,
            currentProgressStatus: [],
            isProgressStatusLoading: false,

            selectedTeam: null,
            currentTeam: [],
            isTeamLoading: false,

            selectedUser: null,
            currentUser: [],
            isUserLoading: false,

            isIsometricLoading: false,
            isDrawingLoading: false,
            selectedIsometrics: null,
            currentIsometrics: [],

            currentReason: [],
            isReasonLoading: false,

            file_id: null,
            isFileDelete: false,

            hasFilesReadPermission: false,
            hasFilesDeletePermission: false,
            getData: {
                rowData: [],
                isometricsData: [],
                drawingsData: [],
                getFiles: [],
                rowColors: [],
            },
            model: {
				line_id: null,
				document_id: null,
				revision_number: null,
				team_id: null,
				user_id: null,
				tie_in_nr: null,
				tie_in_type: null,
				size: null,
				rating: null,
				field_area: null,
				old_line_number: null,
				p_and_id: null,
				item_number: null,
				drawing_number: null,
				priority: null,
				project_setting_id: null,
				scaffolding: null,
				scaffolding_date: null,
				ndt: null,
                wall_thickness_measure: null,
                wall_thickness_measure_date: null,
				insulation_to_remove: null,
				insulation_to_remove_date: null,
				pressure_test: null,
				pressure_test_date: null,
				authorization_authority: null,
				authorization_authority_date: null,
				special_coating: null,
				special_works_date: null,
				painting: null,
				painting_code: null,
				heat_tracing: null,
				heat_tracing_date: null,
				supports: null,
				supports_date: null,
				golden_welds: null,
				golden_welds_date: null,
				work_finished: null,
				remark: null,
                date: null,
                file: null,
                line: {
                    tie_in_no: null,
                    testing_pressure: null,
                    testing_medium: null,
                    ped_category: null,
                    pwht: null,
                    insulation_or_tracing_type: null,
                    insulation_or_tracing_thickness: null,
                },
                revision_date: null,
                revision_number: null,
                revision_description: null,
                revision_reason: null,
                revision_reason_setting: null,
                revision_remarks: null,
            },
            isometricsColumnData: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    showDeleteButton: true,
                },
                {
                    label: Vue.i18n.translate('table.isometric'),
                    width: '220px',
                    field: 'info',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.tie_in_no'),
                    field: 'line.tie_in_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.testing_medium'),
                    field: 'line.testing_med',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.testing_pressure'),
                    field: 'line.testing_press',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.ped_category'),
                    field: 'line.ped_category',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.p_and_id_no'),
                    field: 'line.p_and_id_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.painting_code'),
                    field: 'line.painting_code',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.insulation_or_tracing_thickness'),
                    field: 'line.insulation_or_tracing_thickness',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.insulation_or_tracing_type'),
                    field: 'line.insulation_or_tracing_type',
                    numeric: false,
                    html: false,
                },
            ],
            drawingsColumnData: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    showDeleteButton: true,
                },
                {
                    label: Vue.i18n.translate('table.drawing'),
                    field: 'info',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.discipline'),
                    field: 'discipline.name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.delayed'),
                    field: 'delayed',
                    numeric: false,
                    html: false,
                    showAsCheckRed: true,
                    cursor: false
                },
                {
                    label: Vue.i18n.translate('table.priority'),
                    field: 'priority',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.progress_status'),
                    field: 'progress_status_percentage',
                    numeric: false,
                    html: false,
                }
            ]
        }
    },
    mounted() {
        this.$refs.rt.load('tie_in?project_id='+this.$route.params.id+'&filters[parent_tie_in_id]='+ this.$route.params.id2);

        this.hasFilesReadPermission   = this.$store.getters.hasPermission(['files'], ['read']);
        this.hasFilesDeletePermission = this.$store.getters.hasPermission(['files'], ['delete']);
    },
	computed: {
        tie_in_types: {
            get: function () {
                let tie_in_types = this.$store.getters.getTieInTypes;
                return tie_in_types;
            }
        },
		priorities: {
            get: function () {
                let priorities = this.$store.getters.getDrawingPriority;
                return priorities;
            }
        },
    },
    watch: {
        tie_in_types: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        },
		priorities: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        },
    },
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        clearSearches () {
            this.currentLine           = [];
            this.currentProgressStatus = [];
            this.currentTeam           = [];
            this.currentUser           = [];

            this.selectedLine           = null;
            this.selectedProgressStatus = null;
            this.selectedTeam           = null;
            this.selectedUser           = null;

            this.getData.getFiles = [];
            this.$nextTick(() => {
                if (typeof this.$refs.document != 'undefined') {
                    this.$refs.document.removeAllFiles();
                }
            });
        },
        async onAddRow() {
			this.actionTitle =  Vue.i18n.translate('general.revision.create_button');
			this.row = null;

			this.model.revision_date           = null;
			this.model.revision_description    = null;
			this.model.revision_reason         = null;
			this.model.revision_reason_setting = null;
			this.model.revision_remarks        = null;

			await this.findLastRevisionNumber('tie_in/'+this.$route.params.id2+'/maxrevision?project_id='+this.$route.params.id);

			this.$refs.addModal.show();
		},
        findLastRevisionNumber(request) {
			return new Promise(resolve => {
				http.route(request).get().then(response => {
                    if (!response.isError) {
					    this.model.revision_number = response.data+1;
                    } else {
					    this.model.revision_number = null;
					}
					resolve(this.model.revision_number);
				});
			});
		},
        onEditRow (row) {
            this.actionTitle = Vue.i18n.translate('general.revision.edit_button');
			this.row = row;
            this.clearSearches();
            this.loadIsometrics();
            
            if (this.hasFilesReadPermission) {
                this.onViewFiles(this.row.id);
            }

			this.model.revision_number = this.row.revision_number;
			this.model.line_id = this.row.line_id;
			this.model.team_id = this.row.team_id;
			this.model.user_id = this.row.user_id;
            this.model.tie_in_type = this.row.tie_in_type;
            this.model.tie_in_nr = this.row.tie_in_nr;
			this.model.size = this.row.size;
			this.model.rating = this.row.rating;
			this.model.field_area = this.row.field_area;
			this.model.old_line_number = this.row.old_line_number;
			this.model.p_and_id = this.row.p_and_id;
			this.model.item_number = this.row.item_number;
			this.model.priority = this.row.priority;
			this.model.project_setting_id = this.row.project_setting_id;
			this.model.scaffolding = Boolean(this.row.scaffolding);
			this.model.scaffolding_date = this.row.scaffolding_date;
			this.model.insulation_to_remove = Boolean(this.row.insulation_to_remove);
			this.model.insulation_to_remove_date = this.row.insulation_to_remove_date;
			this.model.ndt = this.row.ndt;
			this.model.wall_thickness_measure = Boolean(this.row.wall_thickness_measure);
			this.model.wall_thickness_measure_date = this.row.wall_thickness_measure_date;
			this.model.pressure_test = Boolean(this.row.pressure_test);
			this.model.pressure_test_date = this.row.pressure_test_date;
			this.model.authorization_authority = Boolean(this.row.authorization_authority);
			this.model.authorization_authority_date = this.row.authorization_authority_date;
			this.model.special_coating = Boolean(this.row.special_coating);
			this.model.special_works_date = this.row.special_works_date;
			this.model.painting = Boolean(this.row.painting);
			this.model.painting_date = this.row.painting_date;
			this.model.painting_code = this.row.painting_code;
			this.model.heat_tracing = Boolean(this.row.heat_tracing);
			this.model.heat_tracing_date = this.row.heat_tracing_date;
			this.model.supports = Boolean(this.row.supports);
			this.model.supports_date = this.row.supports_date;
			this.model.golden_welds = Boolean(this.row.golden_welds);
			this.model.golden_welds_date = this.row.golden_welds_date;
			this.model.work_finished = Boolean(this.row.work_finished);
			this.model.remark = this.row.remark;
			this.model.date = this.row.date;
			this.model.drawing_number = this.row.drawing_number;

            this.selectedLine = this.row.line;
            if (this.row.line != null) {
                this.model.line.tie_in_no = this.row.line.tie_in_no;
                this.model.line.testing_pressure = this.row.line.testing_press;
                this.model.line.testing_medium = this.row.line.testing_med;
                this.model.line.ped_category = this.row.line.ped_category;
                this.model.line.pwht = Boolean(this.row.line.pwht);
                this.model.line.insulation_or_tracing_type=this.row.line.insulation_or_tracing_type;
                this.model.line.insulation_or_tracing_thickness = this.row.line.insulation_or_tracing_thickness;
            }
            this.selectedTeam           = this.row.team;
            this.selectedUser           = this.row.user;
            this.selectedProgressStatus = this.row.project_setting;

			this.model.revision_date           = row.revision_date;
			this.model.revision_number         = row.revision_number;
			this.model.revision_description    = row.revision_description;
			this.model.revision_reason         = row.revision_reason;
			this.model.revision_reason_setting = row.revision_reason_setting;
			this.model.revision_remarks        = row.revision_remarks;

            this.$refs.editModal.show();
        },
		saveAction(e) {
            e.preventDefault();

            if (this.model.revision_reason_setting == null) {
                this.model.revision_reason_setting = { 'id': null }
            }
            
            let data = {
                drawing_id: this.model.drawing_id,
                line_id: this.model.line_id,
                team_id: this.model.team_id,
                user_id: this.model.user_id,
                tie_in_nr: this.model.tie_in_nr,
                tie_in_type: this.model.tie_in_type,
                size: this.model.size,
                rating: this.model.rating,
                field_area: this.model.field_area,
                old_line_number: this.model.old_line_number,
                p_and_id: this.model.p_and_id,
                item_number: this.model.item_number,
                priority: this.model.priority,
                project_setting_id: this.model.project_setting_id,
                scaffolding: this.model.scaffolding,
                insulation_to_remove: this.model.insulation_to_remove,
                wall_thickness_measure: this.model.wall_thickness_measure,
                pressure_test: this.model.pressure_test,
                authorization_authority: this.model.authorization_authority,
                special_coating: this.model.special_coating,
                painting: this.model.painting,
                painting_code: this.model.painting_code,
                heat_tracing: this.model.heat_tracing,
                supports: this.model.supports,
                golden_tieins: this.model.golden_tieins,
                work_finished: this.model.work_finished,
                remark: this.model.remark,
                date: this.model.date,
                ndt: this.model.ndt,

                revision_number: this.model.revision_number,
                revision_remarks: this.model.revision_remarks,
                revision_reason: this.model.revision_reason_setting.id,
                revision_description: this.model.revision_description,
                revision_date: this.model.revision_date,

                id: this.model.id,
                project_id: this.$route.params.id,
                from_revision_control: 1,
            }

            Object.keys(data).forEach(key => {
                if (data[key] === '') {
                    data[key] = null;
                }
            });

            if (this.row) {
                data['date'] = data.date ? data.date : null;
                data['id'] = this.$route.params.id2;
                http.route('tie_in/' + this.row.id).patch(data, true).then(response => {
                    if (!response.isError) {
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                        this.$refs.rt.refresh();
                        this.$refs.editModal.hide();
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            } else {
                data['id'] = this.$route.params.id2;
                http.route("tie_in").post(data, true).then(response => {
                    if (!response.isError) {
                        let id = response.data.id;
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.created'));
                        this.$refs.rt.refresh();
                        this.$refs.addModal.hide();
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            }
        },
        onViewFiles (id) {
            this.getData.getFiles.length = 0;
            let data = http.route('file?filters[tie_in_id]=' + id).get();
            data.then(response => {
                if(response.data == false) {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                } else {
                    this.getData.getFiles = response.data;
                }
            });
        },
        onDownloadFile (id) {
            let data = http.route('file/' + id).get({export_pdf: 1}, true);
            data.then(response => {
                if (!response.isError) {
                    this.successMsg(Vue.i18n.translate('messages.file.file_download'));
                    let data = http.route('get_content/file/'+response.data.id+'/'+response.data.file_name).downloadPdf({}, response.data.file_name).then(res => {});
                } else {
                    this.errorMsg(Vue.i18n.translate('messages.file.error_download'));
                }
            });
        },
        onDeleteRow (row, index) {
            this.actionTitleDelete = Vue.i18n.translate('modal.general.delete') + ' ' + this.tableNameTranslated;
            this.deleteMessage = Vue.i18n.translate('messages.delete');
            this.row = row;
            this.file_id = null;
            this.isFileDelete = false;
            this.$refs.deleteModal.show();
        },
        onDeleteFile (id) {
            this.actionTitleDelete = Vue.i18n.translate('messages.delete_file_title');
            this.deleteMessage = Vue.i18n.translate('messages.delete_file');
            this.file_id = id;
            this.isFileDelete = true;
            this.$refs.deleteModal.show();
        },
        deleteAction (button) {
            if (button == 1) {
                if (this.isFileDelete == true) {
                    this.row.file_id = null;
                    let data = http.route(this.tableName + '/' + this.row.id).patch(this.row, true);
                    data.then(response => {
                        if(response.isError == false) {
                            this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                            this.$refs.rt.refresh();
                            let data = http.route('file/' + this.file_id).delete();
                            data.then(response => {
                                this.$refs.deleteModal.hide();
                                this.$refs.rt.refresh();
                                this.successMsg(Vue.i18n.translate('messages.deleted_file_message'));
                                this.$refs.editModal.hide();
                            });
                        } else {
                            this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                        }
                    });
                } else if (this.isFileDelete == false) {
                    let data = http.route(this.tableName + '/' + this.row.id).delete();
                    data.then(response => {
                        if (response.isError == false) {
                            this.$refs.rt.refresh();
                            this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
                        } else {
                            this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                        }
                        this.$refs.deleteModal.hide();
                    });
                }
            } else {
                this.$refs.deleteModal.hide();
            }
        },
        onReturn() {
			this.$router.push({name: 'tie_in_management', params: {id:this.$route.params.id}});
		},
        //Isometrics
        saveIsometricAction(e, type) {
            e.preventDefault();

            if (this.selectedIsometrics == null) {
                switch (type) {
                    case 'isometric':
                        this.errorMsg(Vue.i18n.translate('errors.isometric.required'));
                    break;
                    case 'drawing':
                        this.errorMsg(Vue.i18n.translate('errors.drawing.required'));
                    break;
                }

                return 0;
            }
            
            http.route('tie_in/' + this.row.id + '/drawing').post({
                drawing_id: this.selectedIsometrics.id
            }, true).then(response => {
                if (!response.isError) {
                    this.successMsg(Vue.i18n.translate('general.isometric_management.title_modal') + ' ' + Vue.i18n.translate('messages.created'));
                    this.$refs.addIsometricModal.hide();
                    this.$refs.addDrawingModal.hide();
                    this.$refs.editModal.hide();
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        loadIsometrics() {
            this.getData.isometricsData.splice(0, this.getData.isometricsData.length);
            this.getData.drawingsData.splice(0, this.getData.drawingsData.length);

            http.route('tie_in/' + this.row.id + '/drawing').get().then(response => {
                if (!response.isError) {
                    var data = response.data;

                    data.filter(d => d.discipline_id === this.$store.getters.getDefaultDisciplines.Piping).forEach((field, key) => {
                        this.getData.rowColors[key] = {};
                        if (field.line != null && field.line.tie_in_no !== this.row.tie_in_nr) {
                            this.getData.rowColors[key]['line.tie_in_no'] = '#ff471a';
                        }
                        this.getData.isometricsData.push(field);
                    });

                    data.filter(d => d.discipline_id !== this.$store.getters.getDefaultDisciplines.Piping).forEach((field, key) => {
                        this.getData.drawingsData.push(field);
                    });
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        filterSearch (from, compare) {
            var that = this;
            return from.filter(function(value, key) {
                return !compare.find(x => x.id == value.id);
            });
        },
        onAddIsometric(type) {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + Vue.i18n.translate('general.isometric_management.title_modal');
            this.selectedIsometrics = null;
            this.currentIsometrics  = [];
            this.$refs.addIsometricModal.show();
        },
        onDeleteIsometricRow(row) {
            if (row.iso_no == null) {
                this.actionTitle = Vue.i18n.translate('modal.general.delete') + ' ' + Vue.i18n.translate('table.drawing');
            } else {
                this.actionTitle = Vue.i18n.translate('modal.general.delete') + ' ' + Vue.i18n.translate('table.isometric');
            }
            this.rowIsometric = row;
            this.$refs.deleteIsometricModal.show();
        },
        deleteIsometricAction(button) {
            if(button == 1) {
                http.route('tie_in/' + this.row.id + '/drawing/' + this.rowIsometric.id).delete().then(response => {
                    if (!response.isError) {
                        this.successMsg(Vue.i18n.translate('general.isometric_management.title_modal') + ' ' + Vue.i18n.translate('messages.deleted'));
                    } else {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    }
                    this.onEditRow(this.row);
                });
            }
            this.$refs.deleteIsometricModal.hide();
        },
        //Drawings
        onAddDrawing(type) {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + Vue.i18n.translate('table.drawing');
            this.selectedIsometrics = null;
            this.currentIsometrics  = [];
            this.$refs.addDrawingModal.show();
        },
        tieInBlur() {
            this.isLineLoading = true;
            this.currentLine = [];

            http.route('line?project_id='+this.$route.params.id+'&filters[parent_line_id]=null&filters[tie_in_no]='+this.model.tie_in_nr).get().then(response => {
                if (response.data.length > 0) {
                    this.currentLine = response.data;
                }
                this.isLineLoading = false;
            });
        },
        onLineSearch(search) {
            if (search == '') {
                this.currentLine = [];
                
                return false;
            }

            this.isLineLoading = true;
            this.searchLine(search, this);
        },
        searchLine: _.debounce((search, vm) => {
            http.route('line?project_id='+vm.$route.params.id+'&get_all=1&search_select='+search+'&filters[parent_line_id]=null&filters[tie_in_no]='+vm.model.tie_in_nr).get().then(response => {
                if (response.data != false) {
                    vm.currentLine = response.data;
                }
                vm.isLineLoading = false;
            });
        }, 500),
        updateLine(line) {
            if (line == null) {
                this.model.line_id                              = null;
                this.model.line.tie_in_no                       = null;
                this.model.line.testing_pressure                = null;
                this.model.line.testing_medium                  = null;
                this.model.line.ped_category                    = null;
                this.model.line.pwht                            = false;
                this.model.line.insulation_or_tracing_type      = null;
                this.model.line.insulation_or_tracing_thickness = null;
            } else {
                this.model.line_id                              = line.id;
                this.model.line.tie_in_no                       = line.tie_in_no;
                this.model.line.testing_pressure                = line.testing_press;
                this.model.line.testing_medium                  = line.testing_med;
                this.model.line.ped_category                    = line.ped_category;
                this.model.line.pwht                            = Boolean(line.pwht);      
                this.model.line.insulation_or_tracing_type      = line.insulation_or_tracing_type;
                this.model.line.insulation_or_tracing_thickness = line.insulation_or_tracing_thickness;
            }
        },
        clearSelectedLine () {
            this.selectedLine = null;
            this.model.line_id                              = null;
            this.model.line.tie_in_no                       = null;
            this.model.line.testing_pressure                = null;
            this.model.line.testing_medium                  = null;
            this.model.line.ped_category                    = null;
            this.model.line.pwht                            = false;
            this.model.line.insulation_or_tracing_type      = null;
            this.model.line.insulation_or_tracing_thickness = null;
        },
        onProgressStatusSearch(search) {
            if (search == '') {
                this.currentProgressStatus = [];
                
                return false;
            }

            this.isProgressStatusLoading = true;
            this.searchProgressStatus(search, this);
        },
        searchProgressStatus: _.debounce((search, vm) => {
            let data = http.route('projectsetting?project_id='+vm.$route.params.id+'&get_all=1&search_select_key_and_value=' + search + '&filters[type]=piping_progress').get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentProgressStatus = response.data;
                }
                vm.isProgressStatusLoading = false;
            });
        }, 500),
        updateProgressStatus(project_setting) {
            this.model.project_setting_id = (project_setting != null) ? project_setting.id : null;
        },
        clearSelectedProgressStatus () {
            this.selectedProgressStatus   = null;
            this.model.project_setting_id = null;
        }, 
        onTeamSearch(search) {
            if (search == '') {
                this.currentTeam = [];
                
                return false;
            }

            this.isTeamLoading = true;
            this.searchTeam(search, this);
        },
        searchTeam: _.debounce((search, vm) => {
            let data = http.route('team?project_id=' + vm.$route.params.id + '&get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentTeam = response.data;
                }
                vm.isTeamLoading = false;
            });
        }, 500),
        updateTeam(team) {
            this.currentUser = [];
            this.clearSelectedUser();

            if (team == null) {
                this.model.team_id = null;
            } else {
                this.model.team_id = team.id;

                http.route('team/' + team.id +'/members?project_id='+this.$route.params.id).get().then(response => {
                    if (response.data != false) {
                        this.selectedUser = null;
                        this.currentUser = response.data;
                    }
                });
            }
        },
        clearSelectedTeam () {
            this.selectedTeam  = null;
            this.model.team_id = null;
            this.clearSelectedUser();
        },
        onUserSearch(search) {
            if (search == '') {
                this.currentUser = [];
                
                return false;
            }

            if (this.model.team_id != null) {
                this.isUserLoading = true;
                this.searchUser(search, this);
            }
        },
        searchUser: _.debounce((search, vm) => {
            let data = http.route('team/' + vm.model.team_id +'/members?project_id='+vm.$route.params.id+'&get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentUser = response.data;
                }
                vm.isUserLoading = false;
            });
        }, 500),
        updateUser(user) {
            this.model.user_id = (user != null) ? user.user_id : null;
        },
        clearSelectedUser () {
            this.selectedUser  = null;
            this.model.user_id = null;
        },
        onDrawingNoSearch(search) {
            if (search == '') {
                this.currentDrawingNo = [];
                
                return false;
            }

            this.currentDrawingNo = [];
            this.searchDrawingNo(search, this);
        },
        searchDrawingNo: _.debounce((search, vm) => {
            let data = http.route('drawing?project_id=' + vm.$route.params.id + '&filters[parent_drawing_id]=null&filters[not_discipline_id]='+1+'&limit=10&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentDrawingNo = [];
                    for (let i = 0; i < response.data.length; i++) {
                        if(response.data[i].drawing_number != null) {
                            vm.currentDrawingNo.push(response.data[i].drawing_number.toString());
                        }
                    }
                }
            });
        }, 500),
        onItemNoSearch(search) {
            if (search == '') {
                this.currentItemNo = [];
                
                return false;
            }

            this.currentItemNo = [];
            this.searchItemNo(search, this);
        },
        searchItemNo: _.debounce((search, vm) => {
            let data = http.route('drawing?project_id=' + vm.$route.params.id + '&filters[parent_drawing_id]=null&filters[not_discipline_id]='+1+'&limit=10&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentItemNo = [];
                    for (let i = 0; i < response.data.length; i++) {
                        if(response.data[i].item_number != null) {
                            vm.currentItemNo.push(response.data[i].item_number.toString());
                        }
                    }
                }
            });
        }, 500),
        onIsometricSearch(search) {
            if (search == '') {
                this.currentIsometrics = [];
                
                return false;
            }

            this.isIsometricLoading = true;
            this.searchIsometric(search, this);
        },
        searchIsometric: _.debounce((search, vm) => {
            let data = http.route('drawing?project_id=' + vm.$route.params.id + '&search_select=' + search + '&filters[parent_drawing_id]=null&filters[discipline_id]='+vm.$store.getters.getDefaultDisciplines.Piping).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentIsometrics = vm.filterSearch(response.data, vm.getData.isometricsData);
                }
                vm.isIsometricLoading = false;
            });
        }, 500),
        onDrawingSearch(search) {
            if (search == '') {
                this.currentIsometrics = [];
                
                return false;
            }

            this.isDrawingLoading = true;
            this.searchDrawing(search, this);
        },
        searchDrawing: _.debounce((search, vm) => {
            let data = http.route('drawing?project_id=' + vm.$route.params.id + '&filters[parent_drawing_id]=null&filters[not_discipline_id]='+vm.$store.getters.getDefaultDisciplines.Piping+'&get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentIsometrics = vm.filterSearch(response.data, vm.getData.drawingsData);
                }
                vm.isDrawingLoading = false;
            });
        }, 500),
        onReasonSearch(search) {
            if (search == '') {
                this.currentReason = [];
                
                return false;
            }

			this.isReasonLoading = true;
			this.searchReason(search, this);
		},
		searchReason: _.debounce((search, vm) => {
			let data = http.route("projectsetting?project_id="+vm.$route.params.id+"&filters[type]=reason_for_revision&get_all=1&search_select=" + search).get();
			data.then(response => {
                if (response.data != false) {
                    vm.currentReason = response.data;
                }
                vm.isReasonLoading = false;
			});
		}, 500),
        clearSelectedProjectSetting () {
			this.model.revision_reason_setting = null;
		},
    }
}
</script>

<style scoped>
    select {
        -webkit-appearance: menulist-button;
        -moz-appearance: menulist-button;
    }
    .dropzone .dz-preview:not(.dz-processing) .dz-progress {
        display: none !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/pages/project/tie_in_management/tie_in_management_revisioncontrol.vue